import Error from 'custom-error';

//
var script = {
  name: "CustomTextArea",
  meta: {
    description: "Componente para entrada de texto multilínea",
    slots: {
      default: {
        type: "component",
        valid: []
      }
    }
  },
  components: {
    Error
  },
  props: {
    id: {
      type: String,
      default: "",
      meta: {
        description: "Id del Componente CustomTextArea",
        example: "idCustomTextArea"
      }
    },
    label: {
      type: String,
      default: "",
      meta: {
        description: "Control para mostrar texto",
        example: "Texto requerido"
      }
    },
    classes: {
      type: Array,
      default: () => new Array(),
      meta: {
        description: "Propiedad para almacenar caracteres",
        example: "4, 8, 15"
      }
    },
    countClasses: {
      type: Array,
      default: () => new Array(),
      meta: {
        description: "Conteo de caracteres",
        example: "16, 23, 42"
      }
    },
    value: {
      type: String,
      default: "",
      meta: {
        description: "Parámetro de entrada en el textarea",
        example: "Texto requerido"
      }
    },
    maxlength: {
      type: Number,
      default: 0,
      required: true,
      meta: {
        description: "Logitud máxima requerida",
        example: "Texto requerido"
      }
    },
    disabled: {
      type: Boolean,
      required: false,
      meta: {
        description: "Estado Disabled",
        example: "true"
      }
    },
    error: {
      type: String,
      default: "",
      meta: {
        description: "Estado Error",
        example: "Texto requerido"
      }
    },
    customErrorMsg: {
      type: String,
      default: function () {
        return this.error;
      },
      meta: {
        description: "Mensaje de error encontrado",
        example: "Texto requerido"
      }
    },
    placeholder: {
      type: String,
      default: "",
      meta: {
        description: "Texto de referencia en el textarea",
        example: "Texto requerido"
      }
    },
    invalid: {
      type: Boolean,
      default: false,
      meta: {
        description: "Propiedad para validar",
        example: "true"
      }
    },
    rows: {
      type: Number,
      default: 0,
      required: false,
      meta: {
        description: "Especifica el número de líneas de texto visibles",
        example: "100"
      }
    },
    showCharCount: {
      type: Boolean,
      default: () => false
    },
    regularLabel: {
      type: Boolean,
      default: () => false,
      meta: {
        description: "Control para mostrar texto en regular",
        example: "true"
      }
    }
  },
  data() {
    return {
      currentValue: ""
    };
  },
  mounted() {
    this.currentValue = this.value;
  },
  methods: {
    getWrapperClass: function () {
      return this.getClasses(this.classes);
    },
    getCountClasses: function () {
      return this.getClasses(this.countClasses);
    },
    getClasses: function (values) {
      return values.map(element => {
        return {
          [element]: true
        };
      });
    },
    updateValue: function (value) {
      this.$emit("input", value);
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.getWrapperClass()
  }, [_vm.label ? _c('label', {
    staticClass: "data-label",
    class: {
      regular: _vm.regularLabel
    }
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "position-relative"
  }, [_c('textarea', {
    staticClass: "form-control",
    class: {
      'was-Invalidated': _vm.error
    },
    attrs: {
      "rows": _vm.rows,
      "id": _vm.id,
      "placeholder": _vm.placeholder,
      "maxlength": _vm.maxlength,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event.target.value);
      }
    }
  }), _vm._v(" "), _vm.error ? _c('i', {
    staticClass: "fa fa-times-circle form-control-icon-invalid"
  }) : _vm._e(), _vm._v(" "), _vm.showCharCount ? _c('span', {
    staticClass: "char-count",
    class: _vm.getCountClasses()
  }, [_vm.maxlength > 0 && _vm.value ? _c('span', [_vm._v(_vm._s(_vm.value.length))]) : _c('span', [_vm._v("0")]), _vm._v("\n      de " + _vm._s(_vm.maxlength) + "\n    ")]) : _vm._e()]), _vm._v(" "), _vm.error ? _c('error', {
    attrs: {
      "variant": "no-border",
      "message": _vm.customErrorMsg
    }
  }) : _vm._e()], 1);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-51581d12_0", {
    source: "textarea[data-v-51581d12]{background:#fff 0 0 no-repeat padding-box;min-height:100px}.small-counter[data-v-51581d12]{--counter-color:#727272;font-size:.8rem;color:var(--counter-color)}span.invalid[data-v-51581d12]:not(input){color:#e85c5c}.regular[data-v-51581d12]{font-weight:400}textarea[data-v-51581d12]:disabled{background:#f8f8f8}textarea[data-v-51581d12]::placeholder{text-align:left;font:Regular 16px/20px Lato;letter-spacing:0;color:#828d99;opacity:1}.form-control[data-v-51581d12]{background:#fff 0 0 no-repeat padding-box;border:1px solid #c5cdcf;opacity:1}.form-control-icon-invalid[data-v-51581d12]{color:#e85c5c;position:absolute;top:9px;right:10px;font-size:19px}.char-count[data-v-51581d12]{margin-top:2px;font-weight:400;font-size:15px}.was-Invalidated[data-v-51581d12],.was-Invalidated[data-v-51581d12]:focus{background-color:#f7d7da;border:1px solid #c5cdcf}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-51581d12";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

// install function executed by Vue.use()
const install = function installCustomTextArea(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('CustomTextArea', __vue_component__);
};

// Inject install function into component - allows component
// to be registered via Vue.use() as well as Vue.component()
__vue_component__.install = install;

// It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export { __vue_component__ as default };
